export enum GridType {
  NONE = "none",
  DOT = "dot",
  FIXED_DOT = "fixedDot",
  MESH = "mesh",
  DOUBLE_MESH = "doubleMesh",
}
